import React from 'react';
import Tooltip from 'design-system/Tooltip';
import CopyToClipboard from 'react-copy-to-clipboard';
import { WorkerSlackChannel } from '@scale/shared/workerSlack/types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface ISlackChannelNameProps {
  channel: WorkerSlackChannel;
  isLoading: boolean;
  isAdd?: boolean;
  isRemove?: boolean;
  isCurrent?: boolean;
  isRecommended?: boolean;
  isHover?: boolean;
  copied?: boolean;
  setCopied?: (copied: boolean) => void;
}

const SlackChannelName = (props: ISlackChannelNameProps) => {
  return (
    <>
      <div className="channel-name">
        {props.isCurrent && !props.isRemove && !props.channel.toEdit && (
          <Tooltip title="Channel is live" placement="top" arrow>
            <div className="status-indicator status-indicator-green"></div>
          </Tooltip>
        )}
        {props.isRecommended && !props.channel.toAdd && (
          <>
            <Tooltip title="Recommended Default Channel" placement="top" arrow>
              <div>
                <FontAwesomeIcon icon="thumbs-up" style={{ color: '#9CA3AF', fontSize: '20px' }} />
              </div>
            </Tooltip>

            <div className="hsp__2" />
          </>
        )}
        {(props.isAdd || props.channel.toAdd) && (
          <Tooltip title="Adding channel pending" placement="top" arrow>
            <div className="status-indicator status-indicator-blue"></div>
          </Tooltip>
        )}
        {!!props.isRemove && (
          <Tooltip title="Remove channel pending" placement="top" arrow>
            <div className="status-indicator status-indicator-red"></div>
          </Tooltip>
        )}
        {!!props.channel.toEdit && (
          <Tooltip title="Edit channel pending" placement="top" arrow>
            <div className="status-indicator status-indicator-gold"></div>
          </Tooltip>
        )}
        <div>#{props.channel.name}</div>
        <div className="hsp__1" />

        <div className="hsp__1" />
        <Tooltip title="Copy" placement="top" arrow>
          <CopyToClipboard text={props.channel.name || ''}>
            {props.isHover ? (
              <div style={{ cursor: 'pointer' }} onClick={() => props.setCopied?.(true)}>
                <FontAwesomeIcon
                  icon={`${props.copied ? `clipboard-check` : `copy`}`}
                  style={{ color: '#9CA3AF', fontSize: '16px' }}
                />
              </div>
            ) : (
              <></>
            )}
          </CopyToClipboard>
        </Tooltip>
      </div>
      <style>{`
        .channel-name {
          display: flex;
          align-items: center;
          width: 500px;
        }

        .members-count {
          color: var(--color-RemoGray75);
          font-size: 14px;
          white-space: nowrap;
        }

        .status-indicator {
          text-align: center;
          padding: 4px;
          border-radius: 12px;
          color: white;
          margin-right: 12px;
          margin-top: 1px;
          width: 6px;
          height: 6px;
        }

        .status-indicator-green {
          background: var(--color-RemoGreen);
        }

        .status-indicator-blue {
          background: var(--color-ScaleBlue);
        }

        .status-indicator-red {
          background: var(--color-RemoRed);
        }

        .status-indicator-gold {
          background: var(--color-RemoGold);
        }
      `}</style>
    </>
  );
};

export default SlackChannelName;
